import { type ReactNode } from 'react';
import { Paragraph } from '@hungryroot/ramen';

import styles from './NewToHungryroot.module.css';

type Props = {
  children: ReactNode;
};

export function NewToHungryroot({ children }: Props) {
  return (
    <div className={styles.new}>
      <Paragraph variant="body">New to Hungryroot?</Paragraph>
      {children}
    </div>
  );
}
